import React from 'react';
import { useForm } from 'react-hook-form';
import { BsInfoCircle } from 'react-icons/bs';
import { useSelector } from 'react-redux';
import { Box, Flex, HStack, Icon, IconButton, Switch, Text, Tooltip } from '@chakra-ui/react';

import { TabNames } from '../../../../../../../../../../../../constants/tabMenuTypes';
import colors from '../../../../../../../../../../../../styles/theme/foundation/colors';
import FormInput from '../../../../../../../../../../../form/FormInput';
import { requiredCustomLanguageStack } from '../formStacks';
import {inAppText} from "../../../../../../../../../../../../constants/inAppText";

function CustomLanguageForm({ formId, onSubmit, blueprint }) {
  const currentEditCustomLanguageId = useSelector(blueprint.selectCurrentEditCustomLanguageId);
  const insuranceLanguages = useSelector(blueprint.selectInsuranceLanguages);
  const activeStep = useSelector(blueprint.selectCreateCustomStep(TabNames.Language));

  const getEditLanguageFormDefaultValues = () => {
    const currentLanguageData = [...insuranceLanguages.data, ...insuranceLanguages.deletedData]
      ?.filter(language => language.id === parseInt(currentEditCustomLanguageId, 10))?.[0];

    const addToList = activeStep !== 2;

    let defaultLanguageValues = {};
    defaultLanguageValues = Object.assign(
      defaultLanguageValues,
      {
        languageName: currentLanguageData?.displayName,
        language: currentLanguageData?.language,
        addToList
      }
    );

    return defaultLanguageValues;
  };

  const useFormMethods = useForm({ defaultValues: (currentEditCustomLanguageId || activeStep === 2)
    ? getEditLanguageFormDefaultValues()
    : { addToList: true } });
  const { handleSubmit, watch, setValue } = useFormMethods;

  return (
    <form id={formId} onSubmit={handleSubmit(onSubmit)}>
      <Box pb={2}>
        {requiredCustomLanguageStack.map(input => (
          <FormInput
            caption={input?.caption}
            inputName={input.name}
            key={input.name}
            labelName={input.label}
            required={input?.required}
            toolTip={input?.toolTip}
            type={input?.type}
            useFormMethods={useFormMethods}
            validationRules={input?.validationRules}
          />
        ))}
      </Box>
      {!currentEditCustomLanguageId && (
        <Flex justify="space-between" mt="26px">
          <HStack flexFlow="row nowrap" w="85%">
            <Text
              color={colors.greyScale['900']}
              textStyle="bodyMd500"
            >
              Save Custom Language to List
            </Text>
            <Tooltip hasArrow
                     label={inAppText.tooltips.templates.templateBuilder.createCustomLang.saveToListToggle}>
              <IconButton
                aria-label="User Help"
                boxSize={1}
                color={colors.greyScale['900']}
                icon={<Icon as={BsInfoCircle} ml={-4} />}
                variant="textGrey"
              />
            </Tooltip>
          </HStack>
          <Box alignItems="flex-end" pr="10px" textAlign="right" w="10%">
            <Switch
              isChecked={watch('addToList')}
              name="addToList"
              size="md"
              width="40px"
              onChange={e => setValue('addToList', e.target.checked)}
            />
          </Box>
        </Flex>
      )}
    </form>
  );
}

export default CustomLanguageForm;
